const state = {
    paymentError: null,
    paymentLoading: false,
    paid: false,
    requiresAction: false,
}

const getters = {
    paymentError: state => state.paymentError,
    paymentLoading: state => state.paymentLoading,
    paid: state => state.paid,
    requiresAction: state => state.requiresAction,

}

const actions = {
    fetchAllSales({commit,getters}) {
        if (!getters.isMerchantSalesLoaded) {
            return axios.get('/merchant/' + Vue.auth.user().merchant_id + '/sales').then((res) => {
                commit('SET_SALES', res.data.data)
                commit('SET_LOADED_MERCHANT', true)
            })
        }
    },
    async pay({commit, dispatch}, payload) {
        return await axios.post('/stripe-connect-payment', {
                paymentMethodId: payload.paymentMethodId,
                orderId: payload.orderId,
            });
    },
    async paymentSuccess({commit, dispatch}, payload) {
        return await axios.post('/stripe-connect-payment-success', {
            metadata: payload,
        });
    }
};

const mutations = {
    SET_PAYMENT_ERROR: (state, value) => (state.paymentError = value),
    SET_PAYMENT_LOADING: (state, value) => state.paymentLoading = value,
    SET_PAID: (state, value) => state.paid = value,
    SET_REQUIRES_ACTION: (state, value) => state.requiresAction = value,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
